import { render, staticRenderFns } from "./masterCard.vue?vue&type=template&id=1cbf169c&scoped=true"
import script from "./masterCard.vue?vue&type=script&lang=js"
export * from "./masterCard.vue?vue&type=script&lang=js"
import style0 from "./masterCard.vue?vue&type=style&index=0&id=1cbf169c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbf169c",
  null
  
)

export default component.exports